import { Response } from 'redux/Common/types'

import { DEFAULT_AUTH_API_CONFIG } from './api.config'

import Api from './api'

export default class AuthApi extends Api {
  constructor() {
    super(DEFAULT_AUTH_API_CONFIG)
  }

  async sendLoginLinkEmail(): Promise<Response<never>> {
    return this.postRequest('/v1/users/me/send-login-link', {})
  }
}
